import { useCallback, useMemo, useState } from "react"

import { useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { PARAM_KEY_RISK_ZONES_ACTIVE_LAYER, RISK_ZONES_DEFAULT_ACTIVE_LAYER, PARAM_KEY_RISK_ZONES_YEAR } from "../../constants/urlParams"
import { useRiskZoneGrades } from "../../hooks/queries/useRiskZoneGrades"

import { initialState, RiskZonesDispatchContext, RiskZonesStateContext } from "./RiskZonesContext.context"

export const RiskZonesContextProvider = (props) => {
    const { children } = props
    const [riskZonesState, setRiskZonesState] = useState(initialState)
    const { getParam, setParam } = useUrlParams()
    const { data } = useRiskZoneGrades({ group_by: "year" })

    const { setImageCollectionCurrentYear } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const currentYear = parseInt(getParam(PARAM_KEY_RISK_ZONES_YEAR)) || data?.filter(item => item.year <= new Date().getFullYear())?.at(-1)?.year || null
    const currentActiveLayer = getParam(PARAM_KEY_RISK_ZONES_ACTIVE_LAYER) || RISK_ZONES_DEFAULT_ACTIVE_LAYER

    const setCurrentYear = useCallback((yearlyStatus) => {
        setParam(PARAM_KEY_RISK_ZONES_YEAR, yearlyStatus?.uuid)
        setImageCollectionCurrentYear(yearlyStatus?.year)
    }, [setImageCollectionCurrentYear, setParam])

    const setCurrentActiveLayer = useCallback((layer) => {
        setParam(PARAM_KEY_RISK_ZONES_ACTIVE_LAYER, layer)
    }, [setParam])

    const setSelectedSegment = useCallback((segment = {}) => {
        const segmentUuid = segment?.properties?.uuid || segment?.uuid || null
        setRiskZonesState(value => ({
            ...value,
            selectedSegmentUuid: segmentUuid,
        }))
        setSelectedLinearLocations(segment)
    }, [setSelectedLinearLocations])

    const stateValue = useMemo(() => {
        return {
            currentActiveLayer,
            currentYear,
            selectedSegmentUuid: riskZonesState.selectedSegmentUuid,
        }
    }, [
        currentActiveLayer,
        currentYear,
        riskZonesState.selectedSegmentUuid])

    const dispatchValue = useMemo(() => {
        return {
            setCurrentActiveLayer,
            setCurrentYear,
            setSelectedSegment: setSelectedSegment,
        }
    }, [setCurrentActiveLayer,
        setCurrentYear,
        setSelectedSegment])

    return (
        <RiskZonesStateContext.Provider value={stateValue}>
            <RiskZonesDispatchContext.Provider value={dispatchValue}>
                {children}
            </RiskZonesDispatchContext.Provider>
        </RiskZonesStateContext.Provider>
    )
}

RiskZonesContextProvider.propTypes = {
    children: PropTypes.node,
}